import React from "react";
import { useState, useEffect, useContext, useRef } from "react";
import { Box } from "@mui/system";
import { SiLinkedin, SiGithub } from "react-icons/si";
import profilePic from "../../assets/imgs/profilepic.png";
import Typewriter from "typewriter-effect";
import {useInView} from 'react-intersection-observer'
import { ThemeContext } from "../../contexts/themeContext";
import { infoTxts } from "../../utils/Texts";

export default function AboutCard() {
  const {ref:aboutSection, inView:aboutVisible, entry} = useInView({
    threshold:1
  })
  const { options, setOptions } = useContext(ThemeContext);
  
  return (
    <div
      ref={aboutSection}
      className={aboutVisible ? "about-card from-shadow-white" : "about-card"}
      /* style={{ display: "flex", alignItems: "start" }}  */ id="about"
    >
      <Box
        className="from-shadow"
        component="img"
        alt="Leandro Loza"
        src={profilePic}
        sx={{
          /*  margin: "1rem 0 0 0", */
          margin: "auto",
          width: "220px",
          height: "220px",
          border: "2px solid black",
          boxShadow: "6px 6px black",
          alignItems: "center",
        }}
      />

      <div className="about-me">
        <h1 className="my-name">Leandro Loza</h1>

        <div>
          <Typewriter
            options={{
              strings: [
                "Full Stack Developer",
                "IT Project Manager",
                "Game Developer",
                "Software Developer",
              ],
              autoStart: true,
              loop: true,
              cursor: "▉",
              delay: 45,
              wrapperClassName: "profile-dev",

              /* █ ▐ ▉ ■  ▇ ▋ ▇  ▖ ▇*/
            }}
          />
        </div>
        <p className="profile-description">
          {!options[2] ? infoTxts.eng : infoTxts.spa}
        </p>
        <br />

        <div className="scl-container">
          <a href="https://linkedin.com/in/leandro-loza" target="_blank">
            <button
              className="tui-button tui-button-w from-shadow-white-but"
              href="https://github.com/CsCt00"
              target="_blank"
            >
              <SiLinkedin />
              <p>LINKEDIN</p>
            </button>
          </a>
          <a href="https://github.com/CsCt00" target="_blank">
            <button className="tui-button tui-button-w from-shadow-white-but">
              <SiGithub />
              <p>GITHUB</p>
            </button>
          </a>
        </div>
      </div>
    </div>
  );
}
